import Vue from 'vue';
import App from './EmbedV2.vue';

const app = new Vue({
  el: '#app',
  render: h => h(App),
});

window.app = app;



// WEBPACK FOOTER //
// ./src/dobrodelen/embed_v2.js